export default "__VITE_ASSET__B_RBca60__"